import React, { Component } from 'react';
import OneSignal from 'react-onesignal';

import {
    Link, Redirect
} from 'react-router-dom'

import {Transaction, TransactionTable} from '../../components/Transactions';
import {EmptyList} from '../../components/EmptyList';
import {LoadingPage, Reconnecting} from '../../components/Loader';
import {Tooltips} from '../../components/Tooltips';

import Queue from './Popup/Queue';

import {config} from '../../config';
import * as QueueActions from '../../actions/Queue';
import {MsgType,Status} from '../../utils/status';
import {formatMoney} from '../../utils/common';
import {connect} from 'react-redux';
import { Pagination } from '../../components/Pagination';
import { refreshToken } from '../../actions/RefreshToken';

let ws;
let reconnectTimeout, loadTimeout, pingTimeout;
let heartbeat_interval = null;
const pingMsg = "ping";
const wsServer = "wss://" + config.WS_HOST + "/v1/ws/join?";
const pageSize = 10;

class Home extends Component {
    constructor(props){
		super(props);
        this.state = {
			todayIncome: 0,
			todayTotalTran: 0,
			todayTotalTranAllStatus: 0,
			transactions: [],
			loadingMore: false,    
            loaded: false,
			reconnecting: false,
			page: 1,
			missed_heartbeats: 0,
			animateNewOrder: false,
			isPayToggled: false,
			isTokenInvalid: false
        }
    }

    sendWsMsg = (type, data) => {		
		const content = {type: type, data: data};
		ws.send(JSON.stringify(content))
    };
    
    handlePing = () => {
		//console.log("Receiving pong message, current misses:", this.state.missed_heartbeats);
		this.setState({
			missed_heartbeats: 0
		});
	};

	handleLoadRequest = (data) => {
		let newData = [];
		if (data?.hasOwnProperty('transactions')) {
			if (data.transactions) {
				newData = data.transactions;
			}
			this.setState({
				transactions: newData,
				loadingMore: false,
				loaded: true,
				todayIncome: data.today_info.today_income > 0 ? data.today_info.today_income : this.state.todayIncome,
				todayTotalTran: data.today_info.today_transaction > 0 ? data.today_info.today_transaction  : this.state.todayTotalTran,
				todayTotalTranAllStatus: data.today_info.total_transaction_all_status > 0 ? data.today_info.total_transaction_all_status : this.state.todayTotalTranAllStatus,
			});
		}
	};

	handleNewOrder = (data) => {
		let newTran =  data.transaction;
		if (newTran) {
			let newList = this.state.transactions;

			if(newTran.status !== Status.REFUND){
				newList.unshift(newTran);
			}
			// if new order is a refund order
			else{ 
				// replace order with status refund
				newList.forEach(tran => tran.merchantcode === newTran.merchantcode ? newTran : tran)
			}

			// cut tail of transactions list if length > 10
			if(newList.length > 10){
				newList.splice(-1,1)
			}
			
			this.setState({
                transactions: newList,
                animateNewOrder: true,
				todayIncome: data.today_income > 0 ? data.today_income : this.state.todayIncome,
				todayTotalTran: data.today_transaction > 0 ? data.today_transaction : this.state.todayTotalTran,
				todayTotalTranAllStatus: data.total_transaction_all_status > 0 ? data.total_transaction_all_status : this.state.todayTotalTranAllStatus,
			});
		}
	};

	handleNewPendingOrder = (data) => {
		this.props.dispatch({type: "ADD_TO_QUEUE", data: data});

		if(document.getElementsByClassName("modal fade show").length === 0){
			this.queueToggle.click();
		}
		
		setTimeout(() =>{
			this.props.dispatch({type: "REMOVE_FROM_QUEUE",data: data})
		}, 30000)
	};
	
	handleConfirmedOrder = (data) =>{
		this.props.dispatch({type: "REMOVE_FROM_QUEUE", data});
	}

	handleErrorCase = (data) => {
		if(data.sub_return_code === 3021) {
			ws.close(3000);
			const token = {
				access_token: this.props.token,
				refresh_token: this.props.data.refresh_token
			}
			this.props.dispatch(refreshToken(token))
		}
	}

	changePage = (pageIndex) => {
		if(pageIndex === this.state.page) return;

		if(pageIndex < 1 || pageIndex > Math.ceil(this.state.todayTotalTranAllStatus/pageSize)) return;

		this.setState({
			page: pageIndex,
			animateNewOrder: false
		}, () => {
			this.loadMore();
		})
	}

    loadMore = () => {
		let self = this;
		let {todayTotalTranAllStatus} = this.state;
		if (self.state.transactions.length < todayTotalTranAllStatus && !self.state.loadingMore) {
			self.setState({
				loadingMore: true,
			}, () => {
				loadTimeout = setTimeout(() => {
					if (ws && ws.readyState === WebSocket.OPEN) {
						try {
							let {page} = self.state;
							//console.log("page", page);
							this.sendWsMsg(MsgType.LoadRequest, {'page': page, 'page_size': pageSize })
						} catch (e) {
							console.log(e)
						}
					}
				}, 500)
			});
		}
    };
    
    sendPing = () => {
		this.sendWsMsg(MsgType.PingPong, pingMsg)
	};

	ping = () => {
		if (heartbeat_interval === null) {
			let self = this;
			heartbeat_interval = setInterval(() => {
				const {missed_heartbeats} = self.state;

				self.setState({
					missed_heartbeats: missed_heartbeats + 1
				}, () => {
					try {
						if (self.state.missed_heartbeats >= 3)
							throw new Error("Too many missed heartbeats.");
						if (ws && ws.readyState === WebSocket.OPEN) {
							this.sendPing()
						} else {
							this.reconnectWS()
							throw new Error("websocket error");
						}
					} catch (e) {
                        console.warn("Closing connection. Reason: " + e.message);
						self.setState({
							transactions: [],
							loadingMore: false,    
							reconnecting: false,
							missed_heartbeats: 1,
							page: 1,
						}, () => {
							if (ws) {
								this.reconnectWS()
							}
							clearInterval(heartbeat_interval);
							heartbeat_interval = null;
						})
					}
				});
			}, 3000);
		}
	};

    onMessage = (res) => {
		let response;
		try {
			response = JSON.parse(res.data);
		} catch (e) {
			response = res.data // only for testing
		}

		switch (response.type) {
			case MsgType.PingPong: {
				this.handlePing();
				break;
			}
			case MsgType.LoadRequest: {
				this.handleLoadRequest(response.data);
				break;
			}
			case MsgType.NewOrder: {
				this.handleNewOrder(response.data);
				break;
			}
			case MsgType.ApproveRequest: {
				this.handleNewPendingOrder(response.data);
				break;
			}
			case MsgType.ConfirmedOrder: {
				this.handleConfirmedOrder(response.data);
				break;
			}
			case MsgType.ErrorNeedToHandle: {
				this.handleErrorCase(response.data)
				break;
			}

			default: {
				this.setState({
					loadingMore: false,
					loaded: true,
				})
			}
		}
	};

	onError = (e) => {
		if (this.state.reconnecting) {
			this.setState({
				reconnecting: false,
			})
		}
		if (e.code === 'ECONNREFUSED') {
			this.reconnectWS()
		} else {
			// this.reconnectWS()
			console.log("socket err ", e)
		}
	};

	onClose = (e) => {
		// console.log(`%cOn close  >> ${JSON.stringify(e.code)}`, 'color: orange');
		if (this.state.reconnecting) {
			this.setState({
				reconnecting: false,
			})
		}
		if (e.code !== 1000 && e.code !== 1006) {
			this.reconnectWS()
		} else if (e.code === 1006) {
			return;
		} else {
			console.log("socket closed ", e.code)
		}
	};

	onOpen = () => {
		pingTimeout = setTimeout(() => this.ping(), 5000);
		this.setState({
			reconnecting: false,
			page: 1,
		});

		if (ws && ws.readyState === WebSocket.OPEN) {
			// ws.send('I\'m a merchant, I connected to u !!!'); // send a message
			this.sendWsMsg(MsgType.InitConnect, '')
		}
	};
	
    setTag = (branchId, storeId, cashierId, appId) => {
		if (branchId) {
			OneSignal?.sendTag("orderTag", appId + "/" + branchId + "/" + storeId + "/" + cashierId);

		}
	};

	reconnectWS = (strToken) => {
		let checkToken = this.props.token
		if (typeof strToken === 'string') {
			checkToken = strToken
		}

		// console.log(`%cReconnect checkToken >> ${checkToken}`, 'background: #222; color: red');
		// console.log(`%cReconnect strToken >> ${strToken}`, 'background: #222; color: #bada55');

		const { appId, branchId, storeId, cashierId } = this.props;
		const query = "app_id=" + appId + "&branch_id=" + branchId + "&store_id=" + storeId + "&cashier_id=" + cashierId + "&pageSize=" + 10 + "&access_token=" + checkToken;
		// console.log(`%cQuery  >> ${checkToken}`, 'background: #222; color: grey');

		//console.log("#####calling reconnectWS");
		reconnectTimeout = setTimeout(() => {
			const {reconnecting} = this.state;
			if (!reconnecting) {
				this.setState({
					loaded: false,
					reconnecting: true
				}, () => {
					//console.log("###reconnecting ...");
					ws = new WebSocket(wsServer + query);
					ws.onopen = this.onOpen;
					ws.onmessage = this.onMessage;
					ws.onerror = this.onError;
					ws.onclose = this.onClose;
				})
			}
		}, 1000)
    };

    handleApprove = (data) => {
		let wsMessage = {
			transactionId: data.transactionId,
			isApproved: true
		}
        this.sendWsMsg(MsgType.ApproveRequest, wsMessage);
        this.props.dispatch(QueueActions.removeFromQueue(data));
    }

    handleCancel = (data) => {
		let wsMessage = {
			transactionId: data.transactionId,
			isApproved: false
		}
        this.sendWsMsg(MsgType.ApproveRequest, wsMessage);
        this.props.dispatch(QueueActions.removeFromQueue(data));
	}
	
	listenNotificationClicked = () => {
		let self = this;
		let {pendingTransactions} = this.props;
		OneSignal?.addListenerForNotificationOpened(function(event) {
			// console.log({event})
			let isNewPendingOrder = event.data;
			if (isNewPendingOrder) {
				if (event.action === "web-approve") {
					self.handleApprove(event.data);
				} else if (event.action === 'web-cancel') {
					self.handleCancel(event.data);
				} else if(!event.action){
					if(!pendingTransactions.find(t => t.transactionId === event.data.transactionId))
						self.handleNewPendingOrder(event.data);
				}
			}
			self.listenNotificationClicked()
		});
	}

    componentDidMount() {
		loadTimeout = setTimeout(() => {
			this.setState({
				loaded: true
			})
		}, 500);

		const {appId, branchId, storeId, cashierId, token} = this.props;

		this.setTag(branchId, storeId, cashierId, appId);		
		this.listenNotificationClicked();
		// console.log(`%cDid mount >> "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE3MDAyMzY3MzEsIm5iZiI6MTY2ODY4MjczMSwicGhvbmUiOiIwOTczNDc4NDk2In0.Ny8vyftB56Q7jFLceALMIq4leQXkXo164MMW6jc8UKA"`, 'color: blue');

		const query = "app_id=" + appId + "&branch_id=" + branchId + "&store_id=" + storeId + "&cashier_id=" + cashierId + "&pageSize=" + 10 + "&access_token=" + token;
		ws = new WebSocket(wsServer + query);

		ws.onopen = this.onOpen;

		ws.onmessage = this.onMessage;

		ws.onerror = this.onError;

		ws.onclose = this.onClose;
	}

    componentWillUnmount(){
		console.log({heartbeat_interval});
        if (ws) {
			ws.close(1000)
		}
        if (reconnectTimeout) clearTimeout(reconnectTimeout);
		if (loadTimeout) clearTimeout(loadTimeout);
		if (pingTimeout) clearTimeout(pingTimeout);
		if (heartbeat_interval) {
			clearInterval(heartbeat_interval);
			heartbeat_interval = null;
		}
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.loggedout) {
			return this.dispatchLogoutProcess()
		} else if (nextProps.token !== this.props.token) {
			this.reconnectWS(nextProps.token)
		}
	}

	dispatchLogoutProcess = () => {
		this.setState({
			isTokenInvalid: true
		})
        this.props.dispatch({type: "USER_LOGOUT"});
        this.props.dispatch({type: "RESET_QUEUE"});
        localStorage.removeItem("persist:root");
		window.OneSignal?.deleteTag("orderTag");
    }

	reloadWhenClickRetryBtn = () => {
		window.location.reload()
	}

    render() {
		let {settingData, data, pendingTransactions} = this.props;

		if (this.state.isTokenInvalid) return <Redirect to="/login"/> 
		if(!settingData.isValidated) return <Redirect to='/setting' />
        let {todayIncome, todayTotalTran, todayTotalTranAllStatus, animateNewOrder,page, loadingMore, transactions,isPayToggled, reconnecting, loaded} = this.state;
        let appName = data.apps ? data.apps.find(app => app.id === this.props.appId).name : "" ;
        let appID = data.apps ? data.apps.find(app => app.id === this.props.appId).id : "" ;
 		let totalList = new Array(Math.ceil(todayTotalTranAllStatus/pageSize)).fill(0);
     const whitelistResubmit = window['runtime_configs'].wl_resubmit;
	
        return (
            <React.Fragment>
            <div className="container-fluid mt-4">

                <div className="text-left text-sm-center">
                    <div className="page-title small-sm">Giao dịch</div>
                </div>

                <div className="right-icons">
					<Link data-tip data-for='history' to="/history" className="mr-4"><img src="/cashier/shop/static/assets/images/icon-history.svg" width="28" alt=""/></Link>
           {Array.isArray(whitelistResubmit) && whitelistResubmit.includes(appID) ?
              <Link data-tip data-for='unreceived' to='/unreceived' className='mr-4'><img src='/cashier/shop/static/assets/images/icon-unreceived.svg' style={{width: '28px', height: '28px'}} alt='' /></Link>
              : undefined
          }
					{/* <a data-tip data-for='quickpay' href="#popupQuickPay" data-toggle="modal" className="mr-4" onClick={() => this.setState({isPayToggled: !isPayToggled})}>
						<img src="/cashier/shop/static/assets/images/icon-quickpay.svg" width="28" alt=""/>
					</a> */}
					{
						settingData.payWaitConfirm ? 
						<a data-tip data-for='pendingtrans' href="#popupQueue" ref={i => this.queueToggle = i} data-toggle="modal" className="mr-4">
							<img src="/cashier/shop/static/assets/images/icon-queue.svg" width="28" alt=""/>
							{
								pendingTransactions.length > 0 ? <span className="counter">{pendingTransactions.length}</span> : null
							}
						</a> : null
					}
                    <Link data-tip data-for='setting' to="/information"><img src="/cashier/shop/static/assets/images/icon-settings.svg" width="28" alt=""/></Link>
                </div>


                <div className="row mt-5">
                    <div className="col-md-6 mb-4">
                        <div className="media">
                            <img className="mr-3" src="/cashier/shop/static/assets/images/logo-mc-default.svg" width="72" alt=""/>
                            <div className="media-body">
                                <div className="mc-name mb-1">{appID + " - " + appName.toUpperCase()}</div>
                                <div className="txtGray fs-s">
									{settingData.branchId + " - " + settingData.branchName}<br/>
									{settingData.storeId + " - " + settingData.storeName} <br/>
									{settingData.cashierId+ " - " + settingData.cashierName}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row mt-1">
                            <div className="col-6 mb-4 text-center summary-col">
                                <div className="fs-s">TỔNG TIỀN GD THÀNH CÔNG TRONG NGÀY</div>
                                <strong className="txtBlack fs-m">{formatMoney(todayIncome,0,"") + " VNĐ"}</strong>
                            </div>
                            <div className="col-6 mb-4 text-center">
                                <div className="fs-s">TỔNG SỐ GD THÀNH CÔNG TRONG NGÀY</div>
                                <strong className="txtBlack fs-m">{todayTotalTran}</strong>
                            </div>
                        </div>
                                
                    </div>
                </div>

                </div>				
				{
					reconnecting || !loaded ? 
					<section className="home-reconnecting-socket">
						<Reconnecting/>
						<button onClick={this.reloadWhenClickRetryBtn} style={{
							padding: '11px 16px',
							background: '#0068FF',
							borderRadius: '8px',
							color: 'white',
							border: 'none',
							width: '140px',
							margin: 'auto',
							display: 'block',
							marginTop: '46px',
						}}>Thử lại</button>
					</section>	
					:
                    todayTotalTranAllStatus > 0 ?
							<>
								<TransactionTable>
									{
										loadingMore ?
											<LoadingPage/>
											:
											transactions.map((value, id) =>
												<Transaction key={id} newOrder={animateNewOrder && id === 0 ? true : false} value={value} key={value.merchantcode} />
											)
									}
								</TransactionTable>

								<Pagination 
									totalList={totalList}
									page={page}
									changePage={this.changePage}
								/>

							</>
							:
							<EmptyList />
                }

                <Queue ref={i => this.queueModal = i} approve={this.handleApprove} cancel={this.handleCancel}/>
				<Tooltips/>

				
            </React.Fragment>
        );
    }
}

const
	mapStateToProps = (state) => {
		return {
			branchId: state.settingData.branchId,
			storeId: state.settingData.storeId,
			cashierId: state.settingData.cashierId,
			appId: state.settingData.appId,
			settingData: state.settingData,
			token: state.loginData.token,
            data: state.loginData.result,
			pendingTransactions: state.queueData.transactions,
			loggedout: state.logoutData.loggedout,
		}
	};

export default connect(mapStateToProps)(Home);
